import React from 'react';
import './App.css';
import './datatable.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

// Import Pages
import Home from './pages';
import Trainingen from './pages/trainingen';
import Luchtdoelschieten from './pages/luchtdoelschieten';
import Nieuws from './pages/nieuws';
import Agenda from './pages/agenda';
import Lidgelden from './pages/lidgelden';
import PostPage from './pages/postPage';
import Privacy from './pages/privacy';
import SeksueleIntimidatie from './pages/seksueleIntimidatie';
import Gedragscode from './pages/gedragscode';
import Reglement from './pages/reglement';
import NewsletterStatusPage from './pages/newsletterStatusPage';

// Admin Pages
import Admin from './pages/admin/admin';
import Dashboard from './pages/admin/dashboard';
import Nieuwsberichten from './pages/admin/nieuwsberichten';

// Authentication Logic & Dashboard Styling
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedLayout from './components/ProtectedLayout';
import Fotos from './pages/fotos';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Main Pages */}
        <Route path='/' element={<Home />} />
        <Route path='/trainingen' element={<Trainingen />} />
        <Route path='/luchtdoelschieten' element={<Luchtdoelschieten />} />
        <Route path='/nieuws' element={<Nieuws />} />
        <Route path='/nieuws/:year/:slug' element={<PostPage />} />
        <Route path='/fotos' element={<Fotos />} />
        <Route path='/agenda' element={<Agenda />} />
        <Route path='/lidgelden' element={<Lidgelden />} />

        {/* Footer Navigation */}
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/grensoverschrijdend-gedrag' element={<SeksueleIntimidatie />} />
        <Route path='/gedragscode' element={<Gedragscode />} />
        <Route path='/reglement' element={<Reglement />} />

        {/* Subscriber Status Page */}
        <Route path="/nieuwsbrief/status" element={<NewsletterStatusPage />} />

        {/* Authentication */}
        <Route path='/admin' element={<Admin />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<ProtectedLayout />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/nieuwsberichten" element={<Nieuwsberichten />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
